import React from 'react';
import { FormBuilder } from 'commons-ui';

import { VIEW_FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from '../../formConfig';

import useView from './useView';

const ViewSegment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useView();

	return (
		<FormBuilder
			data={data}
			mode='view'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={VIEW_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			buttonLabels={{ discardLabel: 'Back', submitLabel: 'Submit' }}
		/>
	);
};

export default ViewSegment;
